// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"VQ","summaryPar":"WQ","ratingCategories":"XQ","reviewerInfo":"YQ","reviewTypes":"ZQ","expanded":"_Q"};